export const GraphContainer = ({ header, children }: { header: React.ReactNode; children: React.ReactNode }) => {
  return (
    <div className="w-full flex flex-col gap-y-4 p-4 md:p-6 rounded-2xl border border-grey-900 relative">
      {header}
      {children}
    </div>
  );
};
